import axios from "axios"
import { Business } from "@/api/interface/business"
import { User } from "@/api/interface/user"
import { Address } from "../interface/address"

export const createPrimaryUser = (user: Partial<User>): Promise<User> =>
  axios.post(`register`, user)

export const resendEmailVerification = () =>
  axios.post(`email/verification-notification`).then((res) => res)

export const createBusiness = (
  business: Partial<Omit<Business, "address"> & { address: Partial<Address> }>
): Promise<Business> =>
  axios.post(`v2/businesses`, business).then((res) => res.data.data)
